import options from './thing-details-labels.component';

export default {
    selector: 'dtThingDetailsLabels',
    options
};
